import gql from 'graphql-tag'
import { orderType } from './fragment'
export default gql`
mutation updateOrderType($id: ID!, $fields: OrderTypeInput) {
	cashAssist {
		updateOrderType(id: $id, fields: $fields) {
            ...orderType
		}
	}
}
${orderType}
`
